var _line, _line2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductionFooterStarLineMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 42,
    viewBox: "0 0 391 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 317.001,
    y1: 20.5,
    x2: 391.001,
    y2: 20.5,
    stroke: "#B0DAC7"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.998676,
    y1: 21.2734,
    x2: 293,
    y2: 20.5,
    stroke: "#B0DAC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.82 33.6777C302.827 27.5927 298.047 22.8123 291.962 20.8193C298.047 18.8263 302.827 14.0459 304.82 7.96082C306.813 14.0459 311.594 18.8262 317.679 20.8193C311.594 22.8123 306.813 27.5927 304.82 33.6777Z",
    stroke: "#B0DAC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionFooterStarLineMobile);
export default __webpack_public_path__ + "static/media/production_footer_star_line_mobile.99165f90.svg";
export { ForwardRef as ReactComponent };